<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handlePageChange"
    :current-page="pagination.actualPagina"
    :pager-count="5"
    :v-model="pagination.currentPage"
    :page-sizes="pagination.perPageOptions"
    :page-size="pagination.perPage"
    layout="slot, sizes, prev, pager, next, jumper"
    :total="pagination.totalItems"
  >
    <span class="el-pagination__total"> {{ totalText }} </span>
  </el-pagination>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    value: {
      required: true,
      default: () => {
        return {
          actualPagina: 0,
          perPage: 20,
          currentPage: 1,
          perPageOptions: [20, 30, 40, 50],
          totalPages: 0,
          totalItems: 0,
        };
      },
    },
  },
  data() {
    return {
      pagination: this.value,
    };
  },
  computed: {
    totalText() {
      return `Total ${
        this.pagination.totalItems == 2000
          ? `+${this.pagination.totalItems}`
          : this.pagination.totalItems
      }`;
    },
  },
  methods: {
    handleSizeChange(val) {
      this.pagination.perPage = val;
      this.$emit("paginationChange", this.pagination);
    },
    handlePageChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.$emit("paginationChange", this.pagination);
    },
  },
  watch: {},
};
</script>
